export class ClientPatientSearchViewModel {
  Filter: string;
  Type: string;
  Status: string;
  OrgId: number;
  OwnerId?: number;
  RegId?: number;
}
